import { ENV } from '@shared/config/env'

const BUGPIN_SCRIPT_URL = 'https://bugpin.auxalia.live/widget.js'
const BUGPIN_API_KEY = 'proj_6c655ae5e17c46d0aba86dcf35d4c458'

/**
 * Environments that load the BugPin widget (AXF-913).
 *
 * An ALLOWLIST, deliberately -- never `!== 'production'`. An unset or misspelled
 * VITE_ENVIRONMENT must leave the widget OFF: an unrecognised API key does not
 * disable the widget, it renders a healthy-looking launcher and silently discards
 * every report. See docs/dev-guide/bugpin-integration-notes.md section 3.
 *
 * Mirrors src/frontend/src/shared/monitoring/bugpin.ts. The duplication is
 * deliberate -- the two apps share no package, and a common "not production"
 * helper would invite reuse by gates with a different risk appetite.
 */
const BUGPIN_ENVIRONMENTS: readonly string[] = ['development', 'staging']

/**
 * Injects the BugPin bug-report widget.
 * Development and staging only -- never loaded in production.
 */
export function initializeBugPin(): void {
  if (!BUGPIN_ENVIRONMENTS.includes(ENV.ENVIRONMENT)) return
  if (document.querySelector(`script[src="${BUGPIN_SCRIPT_URL}"]`)) return

  const script = document.createElement('script')
  script.src = BUGPIN_SCRIPT_URL
  script.async = true
  script.dataset.apiKey = BUGPIN_API_KEY
  document.head.appendChild(script)
}
